import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Fallback translations in case JSON fails
import en from "../Locales/en/translation.json";
import hi from "../Locales/hi/translation.json";

i18n
  .use(LanguageDetector) // auto detect user language
  .use(initReactI18next) // bind with React
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi }
    },
    fallbackLng: "en", // default language
    debug: process.env.NODE_ENV === "development", // log only in dev
    interpolation: {
      escapeValue: false // React already escapes
    },
    react: {
      transSupportBasicHtmlNodes: true, // allows <br>, <strong>, <i>, <p>, <ul>, <li>
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'ul', 'li']
    }
  });

export default i18n;
